import { Button, Form, FormControl, InputGroup, Spinner } from 'react-bootstrap';
import React, { useState } from 'react';
import Select, { components } from 'react-select';
import { useDispatch, useSelector } from 'react-redux';

import FocusLock from 'react-focus-lock';
import { IDatabase } from '../../store/aiearth/types';
// import LoadingButton from '../LoadingButton';
import { Search } from 'react-feather';
import { initialStateDatabase } from '../../store/aiearth/reducer';
import makeAnimated from 'react-select/animated';
import styled from 'styled-components';
import { updateDatebase } from '../../store/aiearth/action';

// import { toast } from 'react-toastify';

interface IRecordNavigationProps {
  onSearchSubmit: (queryText: IDatabase) => void;
  isLoading: boolean;
  masters: any;
  boundingBox?: any;
  setBoundingBox?: any;
  getPageRoute?: any;
}

const RecordNavigationContainer = styled.div`
  padding: 8px;
  padding-bottom: 0;
  /* display: flex; */
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`;

const ProgramQueryContainer = styled(Form)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-radius: 0.5em;
`;

const FormCheck = styled(Form.Check)`
  margin-right: 10px;
  margin-bottom: 8px;
  padding-left: 0 !important;

  .form-check-input {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }

  .form-check-label {
    color: #e2e8f0;
    font-family: var(--sans, 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif);
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.01em;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    line-height: 1;
    border: 1px solid rgba(148, 163, 184, 0.22);
    border-radius: 10px;
    background: rgba(2, 7, 13, 0.88);
    padding: 9px 12px;
    cursor: pointer;
    transition: border-color 0.15s ease, background 0.15s ease;
  }

  .form-check-label::before {
    content: '';
    width: 13px;
    height: 13px;
    border-radius: 3px;
    border: 1px solid rgba(255, 255, 255, 0.85);
    background: transparent;
    color: transparent;
    font-size: 10px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }

  .form-check-input[type='radio'] + .form-check-label::before {
    border-radius: 50%;
  }

  .form-check-input:checked + .form-check-label {
    border-color: #34d399;
    background: rgba(2, 7, 13, 0.88);
  }

  .form-check-input:checked + .form-check-label::before {
    content: '✓';
    border-color: #34d399;
    background: #34d399;
    color: #052e16;
  }
`;

const OptionInputGroup = styled(InputGroup)`
  display: flex !important;
  flex-wrap: wrap;
  align-items: center;
  gap: 0;
`;

const FilterItem = styled.div`
  margin-bottom: 10px;
`;

const CustomInputGroupText = styled(InputGroup.Text)`
  min-width: 118px;
  justify-content: center;
  font-size: 11px !important;
  font-weight: 700 !important;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #94a3b8 !important;
  background: rgba(15, 23, 42, 0.8) !important;
  border: 1px solid rgba(148, 163, 184, 0.28) !important;
  font-family: var(--sans, 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif);
`;

const SourceType = styled(Select)`
  flex: 1 1 auto;
  font-size: 12px;
`;

const QueryFormControl = styled(FormControl)`
  background: rgba(10, 10, 12, 0.92) !important;
  border: 1px solid rgba(148, 163, 184, 0.26) !important;
  color: #e2e8f0 !important;
  font-family: var(--sans, 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif);

  &:focus {
    background: rgba(10, 10, 12, 0.98) !important;
    color: #f8fafc !important;
    border-color: rgba(52, 211, 153, 0.65) !important;
    box-shadow: 0 0 0 0.15rem rgba(52, 211, 153, 0.2) !important;
  }
`;

const ClearFilterButton = styled(Button)`
  margin-right: 15px;
  background: #3aefb8 !important;
  border: none !important;
  color: #000 !important;
  border-radius: 12px !important;
  padding: 0.45rem 0.9rem !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  font-family: 'DM Sans', -apple-system, sans-serif;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  box-shadow: 0 8px 20px rgba(52, 211, 153, 0.28);
  transition: background 0.15s ease, transform 0.12s ease;

  &:hover,
  &:focus,
  &:active {
    background: #63f4ca !important;
    color: #000 !important;
    border: none !important;
    box-shadow: 0 12px 28px rgba(94, 234, 212, 0.32) !important;
    transform: translateY(-1px);
  }
`;

const SearchButton = styled(Button)`
  background: #3aefb8 !important;
  border: none !important;
  color: #000 !important;
  border-radius: 12px !important;
  padding: 0.45rem 0.9rem !important;
  min-width: 44px;
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 20px rgba(52, 211, 153, 0.28);
  transition: background 0.15s ease, transform 0.12s ease;

  &:hover,
  &:focus,
  &:active {
    background: #63f4ca !important;
    color: #000 !important;
    border: none !important;
    box-shadow: 0 12px 28px rgba(94, 234, 212, 0.32) !important;
    transform: translateY(-1px);
  }
`;

const hasAnyFilterApplied = (filters: any) =>
  Object.keys(filters).filter((key: string) => !!filters[key]).length > 0;

const ProgramQuery: React.FC<IRecordNavigationProps> = (props) => {
  const store: any = useSelector<any>((storeState): any => storeState);
  const databaseState: IDatabase = store.database;
  const dispatch = useDispatch();
  const [hasAnyFilter, setHasAnyFilter] = useState(
    hasAnyFilterApplied(databaseState) ? true : false
  );
  const [focusdisabled, setFocusdisabled] = useState(true);
  const [filters, setFilters] = useState<any>(databaseState);

  const sourceOptions: any = {
    tx: [
      { value: 'epa', label: 'EPA' },
      { value: 'tceq', label: 'TCEQ' },
      { value: 'nrc', label: 'NRC' },
      { value: 'rrc', label: 'RRC' },
    ],
    la: [
      { value: 'epa', label: 'EPA' },
      { value: 'nrc', label: 'NRC' },
      { value: 'ldeq', label: 'LDEQ' },
    ],
  };
  const [source, setSource] = useState<any>(
    !!databaseState.source ? databaseState.source : null
  );
  const stateOptions = [
    { value: 'tx', label: 'TX' },
    { value: 'la', label: 'LA' },
  ];
  const [state, setState] = useState(
    !!databaseState.state ? databaseState.state : { value: 'tx', label: 'TX' }
  );
  const countyOptions = !!props.masters
    ? props.masters.counties[filters.state.label]
    : [];
  const [county, setCounty] = useState(
    !!databaseState.county ? databaseState.county : []
  );
  const programOptions = !!props.masters ? props.masters.programs : [];
  const [program, setProgram] = useState(
    !!databaseState.program ? databaseState.program : []
  );
  const animatedComponents = makeAnimated();
  const indicatorStyle = (base: any) => ({
    ...base,
    color: '#dbe3ef',
    padding: '4px',
  });
  const styles = {
    clearIndicator: indicatorStyle,
    dropdownIndicator: indicatorStyle,
    control: (base: any, stateConfig: any) => ({
      ...base,
      minHeight: '44px',
      backgroundColor: 'rgba(10, 10, 12, 0.92)',
      borderColor: stateConfig.isFocused ? 'rgba(52, 211, 153, 0.65)' : 'rgba(148, 163, 184, 0.26)',
      boxShadow: stateConfig.isFocused ? '0 0 0 0.15rem rgba(52, 211, 153, 0.2)' : 'none',
      '&:hover': {
        borderColor: 'rgba(52, 211, 153, 0.6)',
      },
    }),
    menu: (base: any) => ({
      ...base,
      backgroundColor: '#02070d',
      border: '1px solid rgba(148, 163, 184, 0.2)',
      zIndex: 50,
    }),
    singleValue: (base: any) => ({
      ...base,
      color: '#e2e8f0',
    }),
    placeholder: (base: any) => ({
      ...base,
      color: '#94a3b8',
    }),
    input: (base: any) => ({
      ...base,
      color: '#e2e8f0',
    }),
    option: (base: any, optionState: any) => ({
      ...base,
      backgroundColor: optionState.isFocused ? 'rgba(52, 211, 153, 0.18)' : '#02070d',
      color: '#e2e8f0',
    }),
    multiValue: (base: any) => ({
      ...base,
      backgroundColor: 'rgba(30, 41, 59, 0.85)',
    }),
    multiValueLabel: (base: any) => ({
      ...base,
      color: '#e2e8f0',
    }),
    multiValueRemove: (base: any) => ({
      ...base,
      color: '#cbd5e1',
      ':hover': {
        backgroundColor: 'rgba(239, 68, 68, 0.2)',
        color: '#fecaca',
      },
    }),
  };
  const IndicatorsContainer = (properties: any) => {
    return (
      <div style={{ background: 'rgba(15, 23, 42, 0.8)', borderRadius: '0 6px 6px 0' }}>
        <components.IndicatorsContainer {...properties} />
      </div>
    );
  };

  return (
    <FocusLock disabled={focusdisabled}>
      <ProgramQueryContainer
        onMouseLeave={() => {
          dispatch(updateDatebase(filters));
        }}
        onKeyDown={(event: any) => {
          if (event.key === 'Enter') {
            const resetOffset = { ...filters, offset: 0 };
            dispatch(updateDatebase(resetOffset));
            props.onSearchSubmit(resetOffset);
          }
        }}
        onSubmit={(e: React.FormEvent) => {
          e.preventDefault();
          const resetOffset = { ...filters, offset: 0 };
          dispatch(updateDatebase(resetOffset));
          props.onSearchSubmit(resetOffset);
        }}
      >
        <RecordNavigationContainer>
          {props.getPageRoute === '/ai-earth' && (
            <>
              <FilterItem>
                <InputGroup>
                  <InputGroup.Prepend>
                    <CustomInputGroupText id="rn-number-filter">
                      Entity IDs
                    </CustomInputGroupText>
                  </InputGroup.Prepend>
                  <QueryFormControl
                    onFocus={() => {
                      setFocusdisabled(false);
                    }}
                    onChange={(e: any) => {
                      const newFilter = {
                        ...databaseState,
                        rnNumber: e.target.value,
                      };
                      setFilters(newFilter);
                      setHasAnyFilter(hasAnyFilterApplied(newFilter));
                    }}
                    id="pro-query"
                    value={filters.rnNumber}
                    aria-label="RN Number"
                    aria-describedby="rn-number-filter"
                  />
                </InputGroup>
              </FilterItem>
              <FilterItem>
                <InputGroup>
                  <InputGroup.Prepend>
                    <CustomInputGroupText id="entity-name-filter">
                      Entity Names
                    </CustomInputGroupText>
                  </InputGroup.Prepend>
                  <QueryFormControl
                    onFocus={() => {
                      setFocusdisabled(false);
                    }}
                    onChange={(e: any) => {
                      const newFilter = {
                        ...filters,
                        entityName: e.target.value,
                      };
                      setFilters(newFilter);
                      setHasAnyFilter(hasAnyFilterApplied(newFilter));
                    }}
                    value={filters.entityName}
                    aria-label="Entity Name"
                    aria-describedby="entity-name-filter"
                  />
                </InputGroup>
              </FilterItem>
              <FilterItem>
                <InputGroup>
                  <InputGroup.Prepend>
                    <CustomInputGroupText id="street-name-filter">
                      Addresses
                    </CustomInputGroupText>
                  </InputGroup.Prepend>
                  <QueryFormControl
                    onFocus={() => {
                      setFocusdisabled(false);
                    }}
                    onChange={(e: any) => {
                      const newFilter = { ...filters, street: e.target.value };
                      setFilters(newFilter);
                      setHasAnyFilter(hasAnyFilterApplied(newFilter));
                    }}
                    value={filters.street}
                    aria-label="Street"
                    aria-describedby="street-name-filter"
                    autoComplete="street"
                  />
                </InputGroup>
              </FilterItem>
              <FilterItem>
                <InputGroup>
                  <InputGroup.Prepend>
                    <CustomInputGroupText id="city-name-filter">
                      Cities
                    </CustomInputGroupText>
                  </InputGroup.Prepend>
                  <QueryFormControl
                    onFocus={() => {
                      setFocusdisabled(false);
                    }}
                    onChange={(e: any) => {
                      const newFilter = {
                        ...filters,
                        cityName: e.target.value,
                      };
                      setFilters(newFilter);
                      setHasAnyFilter(hasAnyFilterApplied(newFilter));
                    }}
                    value={filters.cityName}
                    aria-label="City Name"
                    aria-describedby="city-name-filter"
                    autoComplete="city"
                  />
                </InputGroup>
              </FilterItem>
              <FilterItem>
                <InputGroup>
                  <InputGroup.Prepend>
                    <CustomInputGroupText id="zip-code-filter">
                      Zips
                    </CustomInputGroupText>
                  </InputGroup.Prepend>
                  <QueryFormControl
                    onFocus={() => {
                      setFocusdisabled(false);
                    }}
                    onChange={(e: any) => {
                      const newFilter = { ...filters, zipCode: e.target.value };
                      setFilters(newFilter);
                      setHasAnyFilter(hasAnyFilterApplied(newFilter));
                    }}
                    value={filters.zipCode}
                    aria-label="Zip Code"
                    autoComplete="zipCode"
                    aria-describedby="zip-code-filter"
                  />
                </InputGroup>
              </FilterItem>
              <FilterItem>
                <InputGroup>
                  <InputGroup.Prepend>
                    <CustomInputGroupText id="state-filter">
                      State
                    </CustomInputGroupText>
                  </InputGroup.Prepend>
                  <SourceType
                    onFocus={() => {
                      setFocusdisabled(false);
                    }}
                    value={state}
                    components={{ IndicatorsContainer, animatedComponents }}
                    closeMenuOnSelect={true}
                    styles={styles}
                    options={stateOptions}
                    onChange={(e: any) => {
                      const newFilter = { ...filters, state: e };
                      setFilters(newFilter);
                      setState(e);
                    }}
                  />
                </InputGroup>
              </FilterItem>
              <FilterItem>
                <InputGroup>
                  <InputGroup.Prepend>
                    <CustomInputGroupText id="county-filter">
                      Counties
                    </CustomInputGroupText>
                  </InputGroup.Prepend>
                  <SourceType
                    onFocus={() => {
                      setFocusdisabled(false);
                    }}
                    value={county}
                    components={{ IndicatorsContainer, animatedComponents }}
                    closeMenuOnSelect={true}
                    isMulti
                    styles={styles}
                    options={countyOptions}
                    onChange={(e: any) => {
                      const newFilter = { ...filters, county: e };
                      setFilters(newFilter);
                      setCounty(e);
                    }}
                  />
                </InputGroup>
              </FilterItem>
              <FilterItem>
                <InputGroup>
                  <InputGroup.Prepend>
                    <CustomInputGroupText id="source-filter">
                      Source
                    </CustomInputGroupText>
                  </InputGroup.Prepend>
                  <SourceType
                    onFocus={() => {
                      setFocusdisabled(false);
                    }}
                    value={source}
                    components={{ IndicatorsContainer, animatedComponents }}
                    closeMenuOnSelect={true}
                    styles={styles}
                    options={sourceOptions[state.value]}
                    isClearable={true}
                    onChange={(e: any) => {
                      const newFilter = { ...filters, source: e };
                      setFilters(newFilter);
                      setSource(e);
                      setProgram([]);
                    }}
                  />
                </InputGroup>
              </FilterItem>
              {source && (
                <FilterItem>
                  <InputGroup>
                    <InputGroup.Prepend>
                      <CustomInputGroupText id="program-filter">
                        Programs
                      </CustomInputGroupText>
                    </InputGroup.Prepend>
                    <SourceType
                      autoFocus
                      onFocus={() => {
                        setFocusdisabled(false);
                      }}
                      value={program}
                      components={{ IndicatorsContainer, animatedComponents }}
                      closeMenuOnSelect={true}
                      isMulti
                      styles={styles}
                      options={programOptions[source.label]}
                      onChange={(e: any) => {
                        const newFilter = { ...filters, program: e };
                        setFilters(newFilter);
                        setProgram(e);
                      }}
                    />
                  </InputGroup>
                </FilterItem>
              )}
              <FilterItem>
                <OptionInputGroup
                  onFocus={() => {
                    setFocusdisabled(false);
                  }}
                >
                  <FormCheck
                    type="checkbox"
                    label="Bounding Box"
                    name="boundingBox"
                    checked={props.boundingBox}
                    onChange={(e: any) => {
                      if (!e.target.checked) {
                        const newFilter = { ...filters, boundingBox: '' };
                        setFilters(newFilter);
                      } else {
                        dispatch(updateDatebase(filters));
                      }
                      props.setBoundingBox(e.target.checked);
                    }}
                  />
                </OptionInputGroup>
              </FilterItem>
              <FilterItem>
                <OptionInputGroup
                  onFocus={() => {
                    setFocusdisabled(false);
                  }}
                >
                  <FormCheck
                    type="radio"
                    label="All"
                    name="mapOptions"
                    value="all"
                    checked={filters.mapOptions === 'all'}
                    onChange={(e: any) => {
                      const newFilter = {
                        ...filters,
                        mapOptions: e.target.value,
                      };
                      setFilters(newFilter);
                      setHasAnyFilter(hasAnyFilterApplied(newFilter));
                    }}
                  />
                  <FormCheck
                    type="radio"
                    label="Mapped"
                    name="mapOptions"
                    value="mapped"
                    checked={filters.mapOptions === 'mapped'}
                    onChange={(e: any) => {
                      const newFilter = {
                        ...filters,
                        mapOptions: e.target.value,
                      };
                      setFilters(newFilter);
                      setHasAnyFilter(hasAnyFilterApplied(newFilter));
                    }}
                  />
                  <FormCheck
                    type="radio"
                    label="Unmapped"
                    name="mapOptions"
                    value="unmapped"
                    checked={filters.mapOptions === 'unmapped'}
                    onChange={(e: any) => {
                      const newFilter = {
                        ...filters,
                        mapOptions: e.target.value,
                      };
                      setFilters(newFilter);
                      setHasAnyFilter(hasAnyFilterApplied(newFilter));
                    }}
                  />
                </OptionInputGroup>
              </FilterItem>
              <ClearFilterButton
                variant="secondary"
                onClick={() => {
                  // toast.info('Cleared advanced search filters.');
                  dispatch(updateDatebase(initialStateDatabase));
                  setHasAnyFilter(false);
                  setSource(false);
                  setCounty(false);
                  props.setBoundingBox(false);
                }}
                onMouseDown={(e: any) => {
                  e.target.click();
                }}
              >
                Clear Filter
              </ClearFilterButton>
            </>
          )}
          {!!hasAnyFilter && (
            <SearchButton type="submit" disabled={props.isLoading || false} name="submitSearch">
              {!props.isLoading && <Search />}
              {props.isLoading && <Spinner animation="border" size="sm" className="cmn-spinner-text-black" />}
            </SearchButton>
          )}
        </RecordNavigationContainer>
      </ProgramQueryContainer>
    </FocusLock>
  );
};

export default ProgramQuery;
